import { api } from "./api";
declare const API_BASE_URL: string;

export const GetSafetyTask = async (
  safetytaskid: number,
  tenantid: number,
  safetystatusid: number,
  isoverdue: boolean
) => {
  try {
    const mallid =
      localStorage.getItem("mall_id") || sessionStorage.getItem("mall_id");

    const url = `/tenant/v1/getsafetytask?safetytaskid=${safetytaskid}&mallid=${mallid}&tenantid=${tenantid}&safetystatusid=${safetystatusid}&isoverdue=${isoverdue}`;
    const response = await api.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const DoneSafetyTask = async (
  SafetyTaskId: number,
  Notes: string,
  safetyTaskImageDatas: Record<string, unknown>[]
) => {
  try {
    const url = `${API_BASE_URL}/tenant/v1/donesafetytask`;
    const payload = {
      SafetyTaskId: SafetyTaskId,
      Notes: Notes,
      safetyTaskImageDatas: safetyTaskImageDatas,
    };

    const response = await api.post(url, payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};
